export default class KioskConstants
{
	public static readonly SESSION_TIMEOUT_SECONDS: number = 60; // Timeout user after 1 minute.
	public static readonly WAITING_ROOM_TIMEOUT_SECONDS: number = 600; // Timeout user after 10 minutes.
	public static readonly ALERT_TIMEOUT_SECONDS: number = 30; // Seconds until timeout from when timeout alert is shown;
	public static readonly VERSION_CHECK_INTERVAL: number = 60000; // check every 60 seconds.
}
